import { fabricaApi } from "@/services/fabricaApi";
import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import deleteModalSlice from "./deleteModal/deleteModalSlice";
import globalSlice from "./globalSlice";
import rolesSlice from "./roles/rolesSlice";

export const rootReducer = combineReducers({
  [fabricaApi.reducerPath]: fabricaApi.reducer,
  global: globalSlice,
  roles: rolesSlice,
  deleteModal: deleteModalSlice,
});
const persistConfig = {
  key: "ops-cyberminuta",
  storage,
  whitelist: ["auth"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          "persist/PERSIST",
          "persist/REHYDRATE",
          "persist/PURGE",
          "persist/FLUSH",
          "persist/PAUSE",
          "persist/REGISTER",
        ],
      },
    }).concat([fabricaApi.middleware]),
});

export const setupStore = (preloadedState?: Partial<RootState>) => {
  return configureStore({
    reducer: rootReducer,
    preloadedState,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredActions: [
            "persist/PERSIST",
            "persist/REHYDRATE",
            "persist/PURGE",
            "persist/FLUSH",
            "persist/PAUSE",
            "persist/REGISTER",
          ],
        },
      }).concat([fabricaApi.middleware]),
  });
};

setupListeners(store.dispatch);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
